export default function logHotelSlugNotProvided(hotelId) {
  console.error('Error: Hotel slug not provided!', hotelId);
  window.Rollbar.error('Error: Hotel slug not provided!', hotelId);
}
